export default {
  MfaProtected__BUTTON_GROUP_ARIA_NEXT: "Next",
  MfaProtected__BUTTON_GROUP_ARIA_PREVIOUS: "Previous",
};
